import moment from "moment";
import config from "../Config/config";

const fetchLogs = async (
  page = 1,
  filters,
  setLogs,
  setPagination,
  setAlert
) => {
  const query = new URLSearchParams({
    ...filters,
    dateFrom: filters.dateFrom
      ? moment(filters.dateFrom).format("YYYY-MM-DD")
      : "",
    dateTo: filters.dateTo ? moment(filters.dateTo).format("YYYY-MM-DD") : "",
    limit: 20,
    page,
  });

  const res = await fetch(`${config.serverBaseUrl}/admin/logs?${query}`, {
    credentials: "include",
  });

  const data = await res.json();
  if (data.success) {
    setLogs(data.data.logs);
    setPagination({
      totalPages: data.data.totalPages,
      currentPage: data.data.currentPage,
    });
  } else {
    setAlert({
      severity: "error",
      message: `Failed to load logs`,
    });
  }
};

export { fetchLogs };
